import { GISServiceTypes } from '../gisServicesTypes';
import { LayerLoader } from './LayerLoader';
import { loadWithProperties } from './defaultLayerLoader';

/**
 * Load a basemap layer.
 * Starts invisible - visibility is controlled by useGISLayersVisibility based on Redux state.
 */
export const basemapLayerLoader: LayerLoader = {
  shouldUseLoader(service) {
    return service.service_type === GISServiceTypes.basemap;
  },
  async load(service) {
    const properties = {
      id: service.gisLayerID,
      visible: true,
      // Basemaps typically don't need attribute data - just geometry for display
      outFields: ['OBJECTID'],
    };

    return loadWithProperties(service, properties);
  },
};
